import { Controller, useFormContext } from "react-hook-form";
import { Form } from "semantic-ui-react";
import { StringUtils } from "utils";

const PriceField = ({ name, label, width, step, disabled, noIcon = false, placeholder = "", required = true, fluid, onChangeCallback }) => {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { value, onChange },
                fieldState: { error },
            }) => (
                <Form.Input
                    {...width ? { width } : {}}
                    readOnly={disabled}
                    name={name}
                    value={value}
                    onChange={(_, { value }) => {
                        onChange({ target: { name, value: StringUtils.formatDecimal(value) } });
                        if (onChangeCallback) {
                            onChangeCallback();
                        }
                    }}
                    placeholder={placeholder}
                    error={error?.message}
                    label={label}
                    required={required}
                    {...(!noIcon ? { icon: "fas fa-dollar-sign", iconPosition: "left" } : {})}
                    {...(step ? { type: "number", step } : {})}
                    fluid={fluid}
                />
            )}
        />
    );
};

export default PriceField;
